module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', {
    attrs: {
      "include": _vm.keepAliveNames
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.FullScreenScanner) ? _c('div', {
    staticClass: "home-float-btn",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "src": "https://file.findmacau.com/xcx/back-index.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("home.title")))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-43e1deb8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = t51X
// module chunks = 87